angular.module('cvsApp').service('getSpecialtyWCMContentService2',['networkService','xdrService', 'getSpecialtyWCMContentModel', 'configManager', function (NS, XS,SCM, CM) {
   	
	function getSpecialtyWCMContentService (){	
		this.getContent = function(moduleName, callBackSuccess, tokenId,version){
			//get url 
			var tid = tokenId || cvsUtility.queryMap.tokenId;
			var url = '';
			var tokenType = (tokenId) ? 'Guest' : 'Login';
			if (tid === '' || tid === undefined) {
				url = CM.getContentUrl('GET_CONTENT',version);
			}
			else {
				url = CM.getApiUrl('GET_CONTENT', tid, tokenType);
			}
			if(url === "URL_ERROR"){

			}else{
				var request = {url:url,
							header:{"Content-Type":"application/xml"},
							timeout:getTimeout("GET_ACCOUNT_BAL"),
							data:getRequestBody(moduleName, tokenId),
							onSuccess:callBackSuccess
						};
				if (cvsUtility.getIEVersion() <= 9) {
					XS.makeRequest(url, getRequestBody(moduleName, tokenId), xdrSuccess, xdrFailiure);
				}
				else {
					var contentPromise = NS.post(request);	
					contentPromise.then(function(data, c, d){
						if(data && data.data){
							var data2 = data.data.replace(/[\n\r\t]+/g,"");
							var formattedResponse = cvsUtility.xmlToJSON(data2);
							if(formattedResponse && formattedResponse.response && formattedResponse.response.status &&formattedResponse.response.status && formattedResponse.response.status.statusCode
							&& formattedResponse.response.status.statusCode=="DBPL0000"){
								callBackSuccess(formattedResponse.response.details);
							}else{
								callBackSuccess({error:true});
							}

						}else{
							callBackSuccess({error:true});
						}
						//send message to parent					
						//cvsUtility.sendPostMessage("SESSION-ALIVE","getSpecialtyWCMContent");
					});			

					contentPromise.error(function() {
					  callBackSuccess({error:true});
					});	
				}
				
			}
							
		};
		function xdrSuccess (data) {
							SCM.setResponse(data);
							callBackSuccess(SCM.getResponse());
						}
		function xdrFailiure () {
			var reason = {};
			reason.getError = function () {
		  		return 'Service Error';
		 	};
		  	callBackSuccess(reason);
		}

		var getRequestBody = function(moduleName, tokenId){
				var date = new Date();			
				var currentYear = date.getFullYear();
				var currentMonth =convertToTwoDigit(date.getMonth() + 1);
				var currentDay = convertToTwoDigit(date.getDate());
				
				var hour = convertToTwoDigit(date.getHours());
				var minute = convertToTwoDigit(date.getMinutes());
				var second = convertToTwoDigit(date.getSeconds());

				var timeStamp = currentYear + '-' + currentMonth + '-' + currentDay + 'T' + hour + ':' + minute + ':' + second;
				
				var tid = tokenId || cvsUtility.queryMap.tokenId;
				var tokenType = (tokenId) ? 'Guest' : 'Login';

				var requestJson = {request:{
								tokenID:tid,
								tokenType:tokenType,
								apiKey:cvsUtility.queryMap.apikey,
								componentName: moduleName,
								timestamp:timeStamp}};               
				
				return cvsUtility.JSONToXml(requestJson);

				function convertToTwoDigit (number) {
					return (number < 10) ? '0' + number : number;
				}
			};			
	}
	
	return new getSpecialtyWCMContentService();	
}]);
